import { numberFieldWithPlaceholderRenderer, currencySymbolRenderer, numberRenderer } from '../../renderers';

export default (table) => {
  
  return {
    type: "float",
    inputType: "number",
    name: "request.override_fte_incentive_target_amount",
    label: "Override Incentive Target Amount",
    section: "HR",
    visible: true,
    editable: (column, data) =>data.request.request_type === 'compensation' || data.request.request_type === 'internalhire',//Adding this feature to internalhire
    renderer: numberFieldWithPlaceholderRenderer,
    before: (value, data, account, config) => currencySymbolRenderer(value, data.request, account, config),
    allow: ['hr1', 'hr2', 'hr3', 'bcb', 
      /* DEM0083831 - N4 Starts */
      "hr4"
      /* DEM0083831 - N4 Ends */
    ],
    placeholder: (value, data, account, config) => numberRenderer(data.request.new_fte_incentive_target_amount),
    width: '200px'
 };
};